import request from '@/utils/request'
const api = {
    getVideoAdvList: 'video_adv/getVideoAdvList',
    getMyAdvList: 'video_adv/getMyAdvList',
    snapUp: 'video_adv/snapUp',
    payAdv: 'video_adv/payAdv',
    payAdvIncome: 'video_adv/payAdvIncome',
}
export default {
    getVideoAdvList(parameter) {
        return request({
            url: api.getVideoAdvList,
            method: "POST",
            data: parameter
        })
    },
    getMyAdvList(parameter) {
        return request({
            url: api.getMyAdvList,
            method: "POST",
            data: parameter
        })
    },
    payAdv(parameter) {
        return request({
            url: api.payAdv,
            method: "POST",
            data: parameter
        })
    },
    payAdvIncome(parameter) {
        return request({
            url: api.payAdvIncome,
            method: "POST",
            data: parameter
        })
    },
    snapUp(parameter) {
        return request({
            url: api.snapUp,
            method: "POST",
            data: parameter
        })
    }
}